<div class="container">
	<div class="row">
		<div class="col">
			<app-form #axonform *ngFor="let formCard of formData"
				[showCardTitles]="true" 
				[formDataInput]="formCard"
				(onImageCaptured)="uploadImage($event)">
			</app-form>
		</div>
	</div>
	<div class="row button-row">
		<div class="col">
			<button type="button" class="btn btn-primary" (click)="previousStep()">{{'BACK' | translate}}</button>
		</div>
		<div class="col text-end">
			<button type="button" class="btn btn-primary" (click)="nextStep()">{{'NEXT' | translate}}</button>
			<!-- <button type="button" class="btn btn-primary" (click)="nextStep()" [disabled]="!isFormValid">Next</button> -->
		</div>
	</div>
</div>

